import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { AppConstants } from "src/app/app.constants";
import { Observable, of } from "rxjs";
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { ErrorHandlerService } from "src/app/core/services/error-handler.service";

@Injectable({
  providedIn: 'root'
})
export class PatentExpirationService {

  constructor(private http: HttpClient, private router: Router, private errorHandlerService: ErrorHandlerService) { }
  getPatentsExpiration(data) {
    return this.http.post(`${AppConstants.API_ENDPOINT}${AppConstants.API.PATENTS_EXPIRATION.GET_PATENT_EXPIRATION}`, data).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }
}
